import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './styles/candidate-list-message.module.css';
import BotMessage from '@/components/chatbot/Layout/messages/BotMessage';
import { addAnswer, skipBlock } from '@/store/slices/chatbotFlow';
import { connect } from 'react-redux';
import Slider from 'react-slick';
import { Button } from 'antd';
import CandidateCard from '@/components/chatbot/Layout/messages/cards/CandidateCard';

const CandidateListMessage = props => {
  const [candidates, setCandidates] = useState([]);
  const sliderConf = {
    dots: false,
    infinite: false,
    adaptiveHeight: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  function isSelected(job) {
    return candidates.some(item => item.id === job.id);
  }

  function select(job) {
    if (isSelected(job))
      setCandidates(candidates.filter(item => item.id !== job.id));
    else setCandidates([...candidates, job]);
  }

  let { data } = props;
  return data?.length > 0 ? (
    <div className={styles.wrapper}>
      <Slider {...sliderConf}>
        {data.map((candidate, i) => (
          <CandidateCard
            isSelected={isSelected(candidate)}
            select={select}
            key={i}
            isActive={props.isActive}
            candidate={candidate}
          />
        ))}
      </Slider>
      {props.isActive && (
        <div className={styles.answers}>
          <Button
            type={'link'}
            size={'large'}
            block
            disabled={candidates?.length === 0}
            onClick={() => props.addAnswer(candidates)}
          >
            Continue
          </Button>
          {props.block?.skip?.enabled === true ? (
            <Button
              type={'link'}
              size={'large'}
              danger
              className={styles.skip}
              block
              onClick={() => props?.skipBlock()}
            >
              {props.block?.skip?.text || 'Skip'}
            </Button>
          ) : null}
        </div>
      )}
    </div>
  ) : (
    <BotMessage
      block={{
        message: 'We currently don’t have any roles to match your skill-set.',
      }}
      isActive={props.isActive}
    />
  );
};

CandidateListMessage.propTypes = {
  isActive: PropTypes.bool.isRequired,
  block: PropTypes.object.isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
};

const mapDispatchToProps = { skipBlock, addAnswer };
export default connect(null, mapDispatchToProps)(CandidateListMessage);
